import { CapacitorHttp } from '@capacitor/core';
import { VDPLAYER_BASE_URL } from '@/services/offline/vdplayerBaseUrl';

// POST em lote das sessões offline pro vdplayer. Retorna `{ status, retryableIndexes }`:
//   - status: HTTP status; 0 = falha de transporte/rede.
//   - retryableIndexes: Set com os ÍNDICES (dentro de `items`) que o servidor não
//     conseguiu gravar por falha transitória (`reason: "error"`, sinalizado com 207).
//
// O caller trata: 2xx → remove da fila os que NÃO estão em retryableIndexes;
// 4xx/5xx → conta tentativa (descarta após N); 0 → mantém pro próximo reconnect
// sem queimar tentativa. Não lança.
//
// Por que o corpo importa: o servidor responde por ITEM. Antes, um 200 com todos os
// itens em `reason:"error"` (ex.: Mongo fora) fazia o caller apagar o chunk inteiro
// da fila — perda silenciosa e definitiva do progresso offline do aluno.
//
// CapacitorHttp (não axios) de propósito, igual ao hlsNativeDownloader: auth.service.js seta
// `authorization` (JWT do EAD) em axios.defaults.headers.common, que sobrescreveria o nosso token
// do vdplayer e quebraria o Guid.TryParse no MachineKeyHandler → 401.
export async function pushOfflineSessions (userEmail, items, token, customerId, debug = false) {
  if (!userEmail || !items || !items.length || !token || !customerId) {
    return { status: 0, retryableIndexes: new Set() };
  }
  try {
    const response = await CapacitorHttp.post({
      url: `${VDPLAYER_BASE_URL}broadcasts/offline-sessions`,
      headers: { Authorization: token, CustomerId: String(customerId), 'Content-Type': 'application/json' },
      data: { userEmail, items },
      connectTimeout: 20000,
      readTimeout: 20000
    });
    if (debug) console.log('[offline-sync] POST offline-sessions →', response.status, response.data);
    return {
      status: response.status || 0,
      retryableIndexes: extractRetryableIndexes(response.data)
    };
  } catch (e) {
    if (debug) console.warn('[offline-sync] POST offline-sessions falhou:', e?.message || e);
    return { status: 0, retryableIndexes: new Set() };
  }
}

// A resposta ecoa `items` na MESMA ordem do envio; casamos por índice. Só
// `reason: "error"` é reenviável — "invalid"/"not-most-recent" são vereditos
// terminais e "user-not-found" (resposta sem `items`) idem. Corpo ausente ou de
// formato inesperado → conjunto vazio, mantendo o comportamento antigo
// (remove tudo) em vez de reenviar em loop.
function extractRetryableIndexes (body) {
  const out = new Set();
  const list = body && body.items;
  if (!Array.isArray(list)) return out;
  list.forEach((entry, i) => {
    if (entry && entry.inserted === false && entry.reason === 'error') out.add(i);
  });
  return out;
}
